import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { IAppUpdateScreenViewModelType } from './IAppUpdateScreenViewModel';
import { component } from '../../Decorators/Component';
import { AnimatedImageView } from '../../Components/Image/AnimatedImageView';
import { ParagraphView } from '../../Components/Typography/Paragraph';
import { PrimaryButtonView } from '../../Components/Buttons/PrimaryButtonView';
import { BaseScreenComponent } from '../BaseScreen/BaseScreenComponent';
export const AppUpdateScreenComponent = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.appUpdate,
    dependencies: {
        viewModel: IAppUpdateScreenViewModelType
    },
    style: {
        container: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            padding: 20,
        },
        content: {
            width: 350
        },
        image: {
            alignItems: 'center',
            width: '100%',
            height: 80,
            marginBottom: 20,
        },
        description: {
            marginBottom: 20,
            textAlign: 'center'
        },
        btn: {
            width: '100%'
        },
    }
})(({ style, viewModel, assets, localization, navigation }) => {
    var _a, _b, _c, _d, _e, _f;
    return (_jsxs(BaseScreenComponent, { navigation: navigation, hideBackButton: (_a = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.version) === null || _a === void 0 ? void 0 : _a.force_update, options: { gestureEnabled: false }, loading: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.loading, errorPopUp: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.error, onErrorDismiss: viewModel === null || viewModel === void 0 ? void 0 : viewModel.dismissError, children: [_jsx(View, { style: style === null || style === void 0 ? void 0 : style.container, children: _jsxs(View, { style: style === null || style === void 0 ? void 0 : style.content, children: [_jsx(AnimatedImageView, { image: ((_b = assets === null || assets === void 0 ? void 0 : assets.images) === null || _b === void 0 ? void 0 : _b.home_logo_url) || ((_c = assets === null || assets === void 0 ? void 0 : assets.images) === null || _c === void 0 ? void 0 : _c.logo_url), resizeMode: 'contain', containerStyle: style === null || style === void 0 ? void 0 : style.image }), !!((_d = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.version) === null || _d === void 0 ? void 0 : _d.description) && (_jsx(ParagraphView, { textStyle: style === null || style === void 0 ? void 0 : style.description, children: (_e = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.version) === null || _e === void 0 ? void 0 : _e.description })), !!((_f = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.version) === null || _f === void 0 ? void 0 : _f.download_url) && (_jsx(PrimaryButtonView, { onPress: viewModel === null || viewModel === void 0 ? void 0 : viewModel.submit, containerStyle: style === null || style === void 0 ? void 0 : style.btn, text: (localization === null || localization === void 0 ? void 0 : localization.submit) || (localization === null || localization === void 0 ? void 0 : localization.update) || 'Update' }))] }) }), _jsx(StatusBar, { translucent: true, style: 'light' })] }));
});
